import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateEntregaObraTermoColumnsDefinition
 */

type Props = {
  onActionDelete: (idEntregaObraClienteTermo: number | null, openState: boolean) => void;
  onReportSubmit: (idEntregaObraClienteTermo: number) => void;

};

export const GenerateEntregaObraClienteTermoColumnsDefinition = ({
  onActionDelete,
  onReportSubmit,
}: Props): GridColDef[] => {
  return [
    {
      field: "nomeTermo",
      filterable: false,
      headerName: "Nome do Termo",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    {
      field: "anexo",
      filterable: false,
      headerName: "Anexo",
      sortable: false,
      valueGetter: (_, row) => row['idEntregaObraClienteTermo'] as number,
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={() => onReportSubmit(value)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Anexo
          </Button>
        );
      },
    },
    {
      field: 'delete',
      sortable: false,
      filterable: false,
      headerName: 'Excluir',
      width: 65,
      valueGetter: (_, row) => row['idEntregaObraClienteTermo'] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onClick={() => { onActionDelete(params.value, true) }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}